<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent: 00em;">I want to thank Amelia and Debra for the considerable time spent helping me with editing this book.</p><br/>
<p style="text-indent: 00em;">Mat for his contribution to the cover design.</p><br/>
<p style="text-indent: 00em;">Heather for her ever-present interest and support over the two years I worked on this.</p>
<p style="text-indent: 00em;"><strong><br/>
</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?7fad6701